module.exports = __webpack_public_path__ + "static/new-home-screenshot-4d8a043e848d802dcb9090c3c0346081.png";